import message from '~/assets/icons/message.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { IPhoneContactPresence, IPhoneDialog } from '~/shared';
import { useContactName } from '../../hooks/useContactName';
import { MessengerStages } from '../../models/Messenger';
import { setActiveMessengerState, useLayoutDispatch } from '../../redux';
import { AppMessengerDialogItem } from '../AppMessengerDialogItem';
import {
	StyledContainer,
	StyledDialogsListContainer,
	StyledHead,
	StyledNewMessageButton,
	StyledNoDialogsContainer,
} from './AppMessengerDialogsTab.styled';

const DialogRow = ({
	dialog,
	presenceList,
	onClick,
}: {
	dialog: IPhoneDialog;
	presenceList?: IPhoneContactPresence[];
	onClick: () => void;
}) => {
	const contactName = useContactName(dialog.peer.phoneNumber);
	const displayName =
		contactName || dialog.peer.name || dialog.peer.phoneNumber;

	const isOnline =
		!!presenceList &&
		presenceList.some(
			(item) => item.phoneNumber === dialog.peer.phoneNumber && item.isOnline,
		);

	const time = dialog.lastMessage
		? new Date(dialog.lastMessage.createdAt).toLocaleTimeString('ru-RU', {
				hour: '2-digit',
				minute: '2-digit',
				timeZone: 'Europe/Moscow',
		  })
		: '';

	return (
		<AppMessengerDialogItem
			key={dialog.id}
			name={displayName}
			online={isOnline}
			active={false}
			time={time}
			unread={dialog.unreadCount > 0}
			unreadCount={dialog.unreadCount}
			lastMessage={dialog.lastMessage?.text}
			onClick={onClick}
		/>
	);
};

const AppMessengerDialogsTab = () => {
	const dispatch = useLayoutDispatch();

	const dialogs = useObservable<IPhoneDialog[]>(rage.messages.getDialogs());
	const presenceList = useObservable<IPhoneContactPresence[]>(
		rage.messages.getContactsPresence(),
	);

	const handleDialogClick = (dialogId: number) => {
		rage.messages.setActiveDialogId(dialogId);
		dispatch(setActiveMessengerState(MessengerStages.DIALOG));
	};

	return (
		<StyledContainer>
			<StyledHead>
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Сообщения
				</Text>
				<StyledNewMessageButton
					src={message}
					onClick={() => {
						dispatch(setActiveMessengerState(MessengerStages.NEW_DIALOG));
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
			</StyledHead>
			{dialogs.length === 0 ? (
				<StyledNoDialogsContainer>
					<Text>У вас нет сообщений</Text>
				</StyledNoDialogsContainer>
			) : (
				<StyledDialogsListContainer tabIndex={-1}>
					{dialogs?.map((dialog) => (
						<DialogRow
							key={dialog.id}
							dialog={dialog}
							presenceList={presenceList}
							onClick={() => handleDialogClick(dialog.id)}
						/>
					))}
				</StyledDialogsListContainer>
			)}
		</StyledContainer>
	);
};

export { AppMessengerDialogsTab };
